import axios from "axios";
import { buildApiUrl } from "../config/api";

export const TERM_DEPARTURE_OPTIONS = [
    { value: "Left", label: "Left school (transferred elsewhere)" },
    { value: "Expelled", label: "Expelled" },
    { value: "Inactive", label: "Not returning next term" },
];

export async function fetchRolloverPreview(schoolId, { academicYear } = {}) {
    const params = {};
    if (academicYear) params.academicYear = academicYear;
    const { data } = await axios.get(buildApiUrl(`/SchoolRollover/${schoolId}/preview`), { params });
    return data;
}

export async function fetchActiveStudentsForRollover(schoolId) {
    const { data } = await axios.get(buildApiUrl(`/SchoolRollover/${schoolId}/active-students`));
    return data;
}

export async function markTermDepartures(schoolId, { studentIds, status, note }) {
    const { data } = await axios.post(buildApiUrl(`/SchoolRollover/${schoolId}/term-departures`), {
        studentIds,
        status,
        note,
    });
    return data;
}

export async function runYearPromotion(schoolId, { academicYear, reviewYear, force } = {}) {
    const { data } = await axios.post(buildApiUrl(`/SchoolRollover/${schoolId}/year-promotion`), {
        academicYear,
        reviewYear,
        force: Boolean(force),
    });
    return data;
}

export { downloadPromotionReport, fetchPromotionReportMeta } from "./termPromotionReviewApi";
